<template lang="html">
  <div class="widget">
    <div v-if="!nolabels" class="widget-header">
      Visibilidad de <br>
      <strong>tu publicación</strong>
    </div>
    <div class="widget-content">
      <div class="label">
        <svg
          style="display: block; width: 100%;"
          viewBox="0 0 100 100">
          <text
            font-size="42"
            :fill="`hsl(${hue}, 80%, 50%)`"
            x="50%" y="50%"
            dominant-baseline="middle"
            text-anchor="middle" >
            {{ label }}
          </text>
        </svg>
      </div>
      <div class="shadow"></div>
      <div :class="`pie progress-${progress}`"></div>
      <div class="pie-inner"></div>
    </div>
    <div v-if="!nolabels" class="widget-footer mt-3">
      Completá más campos para tener mayor visibilidad
    </div>
  </div>
</template>

<script>
export default {
  props: {
    completed: Number,
    nolabels: Boolean
  },

  computed: {
    label () { return `${this.completed || 0}%` },

    progress () { return Math.round(this.completed / 5) * 5 },

    hue () { return Math.round(this.completed * (173 - 115) / 100 + 115) }
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  $color-low: green;
  $color-high: cyan;
  $color-shadow: $gray-400;
  $font-size: 3rem;
  $ring-space: 6%;

  @mixin toPolygon($percent) {
    @if $percent < 25 {
      $a: $percent * 4;
      clip-path: polygon(50% 50%, 0% 0%, #{$a + '%'} 0%);
    }
    @elseif $percent < 50 {
      $a: ($percent - 25) * 4;
      clip-path: polygon(50% 50%, 0% 0%, 100% 0%, 100% #{$a + '%'});
    }
    @elseif $percent < 75 {
      $a: ($percent - 50) * 4;
      $b: 100 - $a;
      clip-path: polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, #{$b + '%'} 100%);
    }
    @else {
      $a: ($percent - 75) * 4;
      $b: 100 - $a;
      clip-path: polygon(50% 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% #{$b + '%'});
    }
  }

  @for $i from 0 through 20 {
    $p: $i * 5;
    .progress-#{$p} {
      @include toPolygon($p);
    }
  }

  .widget {
    max-width: 180px !important;

    &-header {
      padding: 0 2rem;
      text-align: center;
    }

    &-content {
      position: relative;
      // border: solid 1px red;
      width: 100%;
      padding-top: 100%;

      & .label {
        font-weight: lighter;
        color: $color-low;
        position: absolute;
        z-index: 4;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 60%;
        height: 54%;
      }

      & .shadow {
        position: absolute;
        top: $ring-space;
        bottom: $ring-space;
        left: $ring-space;
        right: $ring-space;
        border-radius: 50%;
        background-color: $color-shadow;
      }

      & .pie {
        position: absolute;
        top: $ring-space;
        bottom: $ring-space;
        left: $ring-space;
        right: $ring-space;
        border-radius: 50%;
        transform: rotateZ(45deg);
        z-index: 1;
        background: linear-gradient(230deg, $color-low, $color-high);
        padding: 1rem;

        &-inner {
          position: absolute;
          top: 14%;
          bottom: 14%;
          left: 14%;
          right: 14%;
          z-index: 3;
          background-color: white;
          border-radius: 50%;
        }
      }
    }

    &-footer {
      color: #2c962c;
      font-weight: bold;
      padding: 0 0.5rem;
      text-align: center;
    }
  }

  @media screen and (min-width:  map-get($grid-breakpoints, "sm")) {
    .widget {
      &-content {
        & .label {
          font-size: 4vw;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/SellWidget.vue